import { mapState, mapGetters, mapActions } from 'vuex'

export const authMethods = mapActions('auth', ['authenticate', 'authorize', 'deauthenticate', 'forgotPassword', 'resetPassword', 'updatePassword'])
export const authComputed = {
  ...mapState('auth', {
    user: (state) => state.user
  })
}

export const userMethods = mapActions('users', ['getUsers', 'getUsersForNextPage', 'getUser', 'resetUser', 'storeUser', 'updateUser', 'enableUser', 'disableUser', 'storeOneTimePassword', 'updateAccount', 'updatePassword', 'sendPasswordResetEmail'])
export const userComputed = {
  ...mapState('users', {
    user: (state) => state.user,
    users: (state) => state.users
  })
}

export const agencyMethods = mapActions('agencies', ['getAgencies', 'getAgency', 'storeAgency', 'updateAgency', 'resetAgency', 'addCoordinator', 'removeCoordinator', 'getCoordinatorLog'])
export const agencyComputed = {
  ...mapState('agencies', {
    agency: (state) => state.agency,
    agencies: (state) => state.agencies
  })
}

export const capabilitiesMethods = mapActions('capabilities', ['getCapabilities', 'updateCapabilities', 'resetCapabilities'])
export const capabilitiesComputed = {
  ...mapState('capabilities', {
    capabilities: (state) => state.capabilities
  })
}

export const programMethods = mapActions('programs', ['getPrograms', 'getProgram', 'storeProgram', 'updateProgram', 'importProgramGraduates', 'setProgramProperty', 'resetProgram', 'resetPrograms', 'activateManagers', 'updateProgramHelpUrl', 'archiveProgram', 'unArchiveProgram'])

export const programComputed = {
  ...mapState('programs', {
    program: (state) => state.program,
    programs: (state) => state.programs
  }),
  ...mapGetters('programs', ['programExists'])
}

export const programGraduateMethods = mapActions('programs/graduates', ['getGraduates', 'resetGraduates', 'storeGraduate', 'updateManagerAssignment', 'activateGraduates'])
export const programGraduateComputed = {
  ...mapState('programs/graduates', {
    graduates: (state) => state.graduates
  })
}

export const graduateMethods = mapActions('graduates', [
  'getGraduates',
  'getGraduatesForNextPage',
  'getGraduate',
  'deleteDocument',
  'addDocument',
  'setGraduatePlacement',
  'setGraduateProperty',
  'updatePerformanceAssessment',
  'storePerformanceAssessment',
  'resetGraduateAssessment'
])
export const graduateComputed = {
  ...mapState('graduates', {
    graduate: (state) => state.graduate,
    graduates: (state) => state.graduates
  }),
  ...mapGetters('graduates', ['graduateExists', 'strengthText'])
}

export const graduateCapabilitiesMethods = mapActions('graduates/capabilities', ['getCapabilities', 'storeCapabilities', 'resetCapabilities'])
export const graduateCapabilitiesComputed = {
  ...mapState('graduates/capabilities', {
    capabilities: (state) => state.capabilities
  })
}

export const managerMethods = mapActions('managers', ['getManagers', 'storeManager', 'addManager', 'setManagerProperty', 'resetManager', 'resetManagers'])
export const managerComputed = {
  ...mapState('managers', {
    manager: (state) => state.manager,
    managers: (state) => state.managers
  }),
  ...mapGetters('managers', ['managersAlpha'])
}

export const placementMethods = mapActions('placements', ['getPlacements', 'getPlacement', 'resetPlacement', 'updateAssignments', 'setPlacementProperty', 'updatePlacement', 'acknowledgeCapabilitiesRequiringDevelopment',
  'updateEndPlacementComponent', 'approveStartComponent', 'approveEndComponent', 'revertEndComponent', 'storeOverallAssessment', 'storeMidPointCheckin', 'getPlacementPdp', 'addStartPlacementComment', 'getStartPlacementComments'])
export const placementComputed = {
  ...mapState('placements', {
    placement: (state) => state.placement,
    placements: (state) => state.placements
  }),
  ...mapGetters('placements', ['placementExists', 'placementStartComponent', 'placementEndComponent', 'groupedCapabilities', 'strengthText', 'placementMidPointCheckin'])
}

export const placementPerformanceObjectiveMethods = mapActions('placements/performanceObjectives', [
  'getPerformanceObjectives', 'storePerformanceObjectives', 'setMilestoneProperty', 'setObjectiveProperty',
  'addBlankMilestone', 'deleteMilestone', 'addBlankObjective', 'deleteObjective', 'updateEndPerformanceObjectives',
  'requestEditAccess', 'approveEditAccess'
])
export const placementPerformanceObjectiveComputed = {
  ...mapState('placements/performanceObjectives', {
    objectives: (state) => state.objectives
  })
}

export const placementDevelopmentObjectiveMethods = mapActions('placements/developmentObjectives', [
  'getDevelopmentObjectives', 'storeDevelopmentObjectives', 'setActionProperty', 'setObjectiveProperty',
  'addBlankAction', 'deleteAction', 'addBlankObjective', 'deleteObjective'
])
export const placementDevelopmentObjectiveComputed = {
  ...mapState('placements/developmentObjectives', {
    objectives: (state) => state.objectives
  })
}

export const placementCapabilitiesMethods = mapActions('placements/capabilities', [
  'getCapabilities', 'storeCapabilities'
])
export const placementCapabilitiesComputed = {
  ...mapState('placements/capabilities', {
    capabilities: (state) => state.capabilities
  })
}

export const taskMethods = mapActions('tasks', [
  'getTasks'
])
export const taskComputed = {
  ...mapState('tasks', {
    tasks: (state) => state.tasks
  })
}

export const dashboardMethods = mapActions('dashboard', [
  'getActivePlacements', 'getGraduatePlacements', 'getAgenciesOverview', 'getUnderperformingGraduates', 'getPlacementCompletion', 'getPerformanceAssessments'
])
export const dashboardComputed = {
  ...mapState('dashboard', {
    placements: (state) => state.placements,
    graduate_placements: (state) => state.graduate_placements,
    agencies: (state) => state.agencies,
    graduates: (state) => state.graduates,
    placement_completion: (state) => state.placement_completion,
    performance_assessments: (state) => state.performance_assessments
  })
}

export const logMethods = mapActions('logs', [
  'getLogs'
])
export const logComputed = {
  ...mapState('logs', {
    logs: (state) => state.logs
  })
}
